import { useClassName } from "@contember/react-utils";
import { createElement } from "react";
import { toViewClass } from "../../utils/toViewClass.js";
function EditorParagraph({ isNumbered, attributes, children, align }) {
  return createElement("p", {
    ...attributes,
    style: {
      textAlign: align
    },
    children,
    className: useClassName("editorParagraph", toViewClass("numbered", isNumbered))
  });
}
export {
  EditorParagraph
};
//# sourceMappingURL=EditorParagraph.js.map
